/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Tout accepter",
      "Nous utilisons des cookies pour assurer le bon fonctionnement de nos services, dont des cookies analytiques et des cookies publicitaires. Pour plus d'informations, consultez notre <a p0>Politique des Cookies</a>.",
      "Gérer les options",
      "Un p'tit cookie ?",
      "Politique des cookies",
      "Gérer les cookies",
      "(ouvre une nouvelle fenêtre)",
      "Fil d'Ariane",
      "Accueil",
      "Pied de page",
      "© {{current_year}} Bumble Tous droits réservés",
      "Créer un profil",
      "Télécharger l'app",
      "Aide",
      "Presse",
      "Confidentialité",
      "Conditions",
      "Page d'accueil de {{partner}}",
      "Proposé par Bumble Inc",
      "À propos",
      "Blog",
      "Carrières",
      "Général",
      "Facebook",
      "Suivre",
      "Instagram",
      "Twitter",
      "Si vous vous sentez mal à l'aise, faites face à une attitude nuisible ou avez simplement besoin de conseils, nous sommes là pour vous aider. Découvrez nos guides pour obtenir de l'aide et des conseils pratiques.",
      "Accueil du Centre de sécurité {{partner}}",
      "Votre sécurité avant tout.",
      "Bienvenue dans notre Centre de sécurité, regardez la vidéo",
      "Plus de guides",
      "Fermer le menu",
      "Guides",
      "Voir les assistances téléphoniques précédentes",
      "Autres assistances téléphoniques",
      "Contacts",
      "Principal",
      "Menu",
      "Ouvrir le menu",
      "Outils",
      "Actualités",
      "Retour",
      "Rafraichissez votre navigateur, ou bien retournez sur la page d'accueil.",
      "Nous n'avons pas trouvé la page que vous cherchez.",
      "Vous avez toujours besoin d'aide ?",
      "Essayer avec un autre terme, ou bien <a href=\"{{feedback_url}}\" class=\"link\">contactez‑nous</a>",
      "Vérifiez votre orthographe.",
      "Soyez moins spécifique pour élargir votre champ de recherche.",
      "Essayez avec des synonymes ou des mots similaires.",
      "Mais ne vous arrêtez pas là pour autant ! Voici quelques conseils :",
      "Autres articles qui pourraient vous intéresser :",
      "Nous n'avons trouvé aucun résultat.",
      "Résultats de recherche",
      "Résultats de recherche pour {{search_query}}",
      "Effacer la recherche",
      "Que pouvons-nous faire pour vous aider ?",
      "Rechercher",
      "Pas de mauvaises vibes, de mots insultants ou de harcèlement sur Bumble. Nous prenons très au sérieux tout signalement, et enquêtons sur chaque cas.",
      "Nous tenons à protéger toute notre communauté. Si quelqu'un vous met mal à l'aise ou en danger, n'hésitez pas à le signaler.",
      "Il n'est pas acceptable de recevoir de contenu sexuel non sollicité. Si quelqu'un vous envoie une photo potentiellement explicite, nous la flouterons d'abord.",
      "Le catfish, c'est quand quelqu'un utilise un faux profil pour vous induire en erreur. Si vous avez besoin d'aide, nous sommes là.",
      "Le harcèlement n'est pas toujours sexuel. Si quelqu'un vous harcèle sur Bumble ou dans la vraie vie, n'hésitez pas à nous contacter.",
      "Vous avez un date ? Super ! Nous sommes là pour vous aider à rester en sécurité, non seulement sur Bumble, mais aussi dans la vraie vie.",
      "Pendant la Covid, les rencontres se sont faites à distance. Voici tout ce que vous devez garder en tête avant de passer de Bumble à la vraie vie.",
      "Votre premier date doit être sympa, et certainement pas dangereux. Voici quelques conseils pour rester en sécurité.",
      "Pas facile de se lancer ou de se remettre au dating... Mais on est là pour vous. Voici quelques conseils pour vous aider à vous y retrouver.",
      "Les rencontres en ligne, ça épuise mentalement. Si vous êtes victime de burnout dû au dating, vous pouvez compter sur notre soutien.",
      "Quand quelqu'un trahit votre confiance, l'estime de soi en prend un coup. Mais nous sommes là pour vous aider à traverser cette épreuve.",
      "Suivez tous nos conseils pour savoir quoi faire quand on se sent victime de rejet.",
      "Sur Bumble, osez être vous et faites des rencontres en toute sécurité. Voici quelques conseils pour vous lancer dans le dating sans risque.",
      "Faites vérifier votre profil pour prouver qu'il est bien réel. Découvrez comment ici : cela ne vous prendra que quelques minutes,",
      "Les scams sont fréquents sur les apps de dating. Voici quelques conseils pour vous protéger, vous et vos infos personnelles.",
      "Pour tout rapport intime, le consentement est de rigueur. Les deux personnes doivent clairement et volontairement exprimer leur désir de participer.",
      "Pas toujours évident de trouver les mots justes... Mais tous nos conseils sont là pour vous aider à envoyer des messages qui feront mouche.",
      "Notre Safety Centre a été conçu pour garantir votre sécurité et vous aider à garder le contrôle, tout au long de votre parcours de dating sur Bumble. Consultez nos guides et outils et profitez de notre assistance téléphonique.",
      "Comportement néfaste | Centre de sécurité Bumble",
      "Signaler un profil | Safety Centre - Bumble",
      "Photos à caractère sexuel | Safety Centre - Bumble",
      "Catfish | Centre de sécurité - Bumble",
      "Harcèlement | Safety Centre - Bumble",
      "Rencontre dans la vraie vie | Safety Centre - Bumble",
      "Dating pendant la Covid | Safety Centre Bumble",
      "Rester safe | Safety Centre - Bumble",
      "Bien‑être mental | Safety Centre - Bumble",
      "Surmonter un burnout dû au dating | Safety Centre - Bumble",
      "Quelqu'un a trahi ma confiance | Safety Centre - Bumble",
      "J'ai peu de Matchs ou de messages | Safety Centre - Bumble",
      "Le dating sans risque | Safety Centre - Bumble",
      "Conseils : Faire vérifier son profil | Safety Centre - Bumble",
      "Conseils : se méfier des scams | Safety Centre - Bumble",
      "Consentement : le donner, le demander | Safety Centre - Bumble",
      "Conseils : Commencer à discuter | Safety Centre - Bumble",
      "Centre de sécurité Rencontres en ligne | Bumble",
      "Télécharger sur l'App Store",
      "Disponible sur Google Play",
      "Fermer le menu",
      "fermer",
      "Voir plus",
      "Nous avons conçu ces outils pour vous aider à rester en sécurité et à garder le contrôle, tout au long de votre parcours de dating. Découvrez comment gérer votre expérience sur Bumble.",
      "Pour plus de conseils et d'infos d'experts sur les tendances en matière de dating, la sexualité, le célibat et bien plus encore, consultez nos derniers articles de blog.",
      "Notre manuel de sécurité",
      "Choix de la langue"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "jours"
            ],
            "singular": [
                  "jour"
            ]
      },
      "hour": {
            "plural": [
                  "heures"
            ],
            "singular": [
                  "heure"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "mois"
            ],
            "singular": [
                  "mois"
            ]
      },
      "second": {
            "plural": [
                  "secondes"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "ans"
            ],
            "singular": [
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
